class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();

    this.recommendationsEl = this.querySelector("cart-drawer-recommendations");
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    console.log("render");
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

class CartDrawerRecommendations extends HTMLElement {
  constructor() {
    super();

    /** @type {CartDrawer} */
    this.cartDrawerEl = document.querySelector("cart-drawer");

    /** @type {CartDrawerRecommendations} */
    this.mainEl = this;
  }

  async connectedCallback() {
    await this.loadRecommendations();
  }

  async loadRecommendations() {
    const { productId } = this.dataset;
    const res = await fetch(
      `${window.Shopify.routes.root}recommendations/products?product_id=${productId}&section_id=cart-drawer`
    );

    const tempDivEl = document.createElement("div");
    const html = await res.text();

    tempDivEl.innerHTML = html;
    const newHTML = tempDivEl.querySelector("cart-drawer-recommendations");
    console.log(newHTML);
    this.innerHTML = newHTML.innerHTML;
    console.log(this);
  }
}

customElements.define("cart-drawer-recommendations", CartDrawerRecommendations);

class CartDrawerRecommendationCard extends HTMLElement {
  constructor() {
    super();

    this.priceEl = this.querySelector("[data-variant-price]");
    this.formEl = this.querySelector("form");
    this.cartNotification = document.querySelector("cart-drawer");
  }

  connectedCallback() {
    this.addEventListener("change", (e) => {
      console.log(e.target.getAttribute("name"));
      if (e.target.getAttribute("name") != "id") return;

      this.updatePrice(e.target);
    });

    this.formEl.addEventListener("submit", (e) => {
      this.handleFormSubmission(e);
    });
  }

  updatePrice(opt) {
    const currentOption = opt.selectedOptions[0];
    const { price } = currentOption.dataset;

    this.priceEl.innerText = price;
  }

  async handleFormSubmission(evt) {
    evt.preventDefault();

    const formData = {
      items: [
        {
          id: this.formEl.querySelector("select").value,
          quantity: 1,
        },
      ],
    };

    const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    const json = await res.json();
    if (res.status != "200") return;
    await this.reloadCartDrawer();
  }

  async reloadCartDrawer() {
    const res = await fetch(
      `${window.Shopify.routes.root}?section_id=cart-drawer`
    );
    const text = await res.text();

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = text;

    document.querySelector("cart-drawer").innerHTML =
      tempDiv.querySelector("cart-drawer").innerHTML;

    document.querySelector("cart-drawer-recommendations").loadRecommendations();
  }
}

customElements.define(
  "cart-drawer-recommendation-card",
  CartDrawerRecommendationCard
);
